const HTTP_PROTOCOL_REGEX = /^http:\/\//i;

function isSecurePage() {
  return typeof window !== 'undefined' && window.location.protocol === 'https:';
}

export default function normalizeBaseDomain(value) {
  // Strip surrounding quotes before anything else: a mis-set env var / CI
  // variable can arrive as `"https://auth.profiteia.io"` (literal quotes). With
  // the quotes the value isn't a valid absolute URL, so axios treats it as a
  // relative path and POSTs to the app origin
  // (…/%22https://auth.profiteia.io%22/oauth/token → 405) instead of the auth
  // host — breaking login for every browser.
  const trimmed = (value || '')
    .trim()
    .replace(/^["']+|["']+$/g, '')
    .trim()
    .replace(/\/+$/, '');

  if (!trimmed) return trimmed;

  if (isSecurePage() && HTTP_PROTOCOL_REGEX.test(trimmed)) {
    return trimmed.replace(HTTP_PROTOCOL_REGEX, 'https://');
  }

  return trimmed;
}
